import styled from "styled-components"
import { customMedia } from "../../styles/customMedia"
import PinesContainer from "../commons/PinesContainer"

export const InvestimentStatistics = styled(PinesContainer)`
  height: auto;
  align-items: center;
  padding: 40px 0;
  background-color: ${({ theme }) => theme.colors.dark};
  position: relative;

  ${customMedia.greaterThan("mediumDesktop")`
    flex-direction: row;
    background-position: top;
    background-size: cover;
    padding: 80px 120px;
    flex-wrap: wrap;
    justify-content: center;

    & > p {
      margin-bottom: 40px;
      font-size: 44px;
    }

    & > button {
      margin-top: 40px;
      width: 392px;
    }
  `}
`

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${customMedia.greaterThan("mediumDesktop")`
    flex-direction: row;
  `}
`

// TODO: Essa formatação no P, infelizmente é um workaround, verificar no componente typography
export const InvestmentDataWrapper = styled.div`
  width: 100%;
  height: auto;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & p {
    margin: 0;
    text-align: center;
  }

  ${customMedia.greaterThan("mediumDesktop")`
    width: 33%;

    & > p:nth-child(1) {
      font-size: 70px;
    }
    & > p:nth-child(2) {
      font-size: 24px;
    }
  `}
`

export const BlueSquare = styled.div`
  position: absolute;
  width: 26px;
  height: 26px;
  bottom: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.info};
  ${customMedia.greaterThan("mediumDesktop")`
    right: 0px;
    left: unset;
    width: 95px;
    height: 95px;
  `}
`

export const WhiteSquare = styled.div`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.gray};
  top: 0px;
  right: 0px;
  width: 26px;
  height: 26px;
  ${customMedia.greaterThan("mediumDesktop")`
    width: 75px;
    height: 75px;
    top: 100px;
    left: 100px;
  `}
`
